/* import __COLOCATED_TEMPLATE__ from './beta-course-label.hbs'; */
import Component from '@glimmer/component';

export interface Signature {
  Element: HTMLDivElement;

  Args: {
    tooltipSide?: 'top' | 'bottom' | 'left' | 'right';
  };

  Blocks: {
    default: [];
  };
}

export default class BetaCourseLabel extends Component<Signature> {
  get tooltipSide(): 'top' | 'bottom' | 'left' | 'right' {
    return this.args.tooltipSide || 'top';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BetaCourseLabel: typeof BetaCourseLabel;
  }
}
